import dueLearnPs from '@/pure/dueLearn';
import { IJoinedProblem, IVuexRootState } from '@/types';
import { endOfToday, isBefore, parseISO } from 'date-fns';


export default {

  /**
   * "MyProblems" are all problems enabled for TS study regardless of due dates.
   * include "own" problems that have been selected for study
   */
  myNewPs(state: IVuexRootState):IJoinedProblem[] {
    return state.joinedProblems.filter(jp => {
      if (jp.state !== 0) return false;
      if (!jp.isSelectedForStudy) return false;
      if (state.showInactiveUnpublished) return true;
      if (jp.author) return true;
      if (jp.isPublished && jp.isLessonActive) return true;
      return false;
    });
  },
  myLearnPs(state: IVuexRootState):IJoinedProblem[] {
    return state.joinedProblems.filter(jp => {
      if (jp.state !== 1 && jp.state !==2) return false;
      if (!jp.isSelectedForStudy) return false;
      if (state.showInactiveUnpublished) return true;
      if (jp.author) return true;
      if (jp.isPublished && jp.isLessonActive) return true;
      return false;
    });
  },
  myReviewPs(state: IVuexRootState):IJoinedProblem[] {
    return state.joinedProblems.filter(jp => {
      if (jp.state !== 3) return false;
      if (!jp.isSelectedForStudy) return false;
      if (state.showInactiveUnpublished) return true;
      if (jp.author) return true;
      if (jp.isPublished && jp.isLessonActive) return true;
      return false;
    });
  },

  /**
   * "MyDueProblems" are due for TS study.
   * "New" problems don't have a due date, so aren't included here.
   */
  myDueLearnPs(
    state: Pick<IVuexRootState, 'user_params' | 'now'>,
    getters: { myLearnPs: IJoinedProblem[] },
  ):IJoinedProblem[] {
    return dueLearnPs(getters.myLearnPs, state.user_params, state.now, endOfToday());
  },
  myDueReviewPs(_state: IVuexRootState, getters: any):IJoinedProblem[] {
    return getters.myReviewPs.filter((jp: IJoinedProblem)=>
      isBefore(parseISO(jp.nextScheduledDate!), endOfToday())
    )
  },














}
